"use client";

import { useEffect, useState } from "react";

type Saude = { status: string; servico: string; ambiente: string; php: string };

// Consulta o Symfony pelo mesmo domínio: /api/ é encaminhado pelo Apache.
export function StatusApi() {
  const [saude, setSaude] = useState<Saude | null>(null);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    fetch("/api/health")
      .then((resposta) => (resposta.ok ? resposta.json() : Promise.reject()))
      .then(setSaude)
      .catch(() => setErro(true));
  }, []);

  if (erro) return <p>Symfony (API): indisponível.</p>;
  if (!saude) return <p>Symfony (API): consultando…</p>;
  return (
    <p>
      Symfony (API): {saude.status} — ambiente {saude.ambiente}, PHP {saude.php}
    </p>
  );
}
